import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { finalize } from 'rxjs/operators';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as _ from 'lodash';
import { AdjuntoService } from '../../../services/adjunto/adjunto.service';
import { Adjunto } from '../../../../model/class/Adjunto';
import { IAdjunto } from '../../../../model/interface/IAdjunto';
import { FileUploader } from 'ng2-file-upload';
import { APP_CONTS } from '../../../app.constants';
import { ImageResizeService } from './../../../services/image-resize.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditAdjuntoComponent } from '../edit-adjunto/edit-adjunto.component';

const TYPE_SLIDE = 'SLIDE';

@Component({
  selector: 'app-adjunto',
  templateUrl: './adjunto.component.html',
  providers: [DragulaService],
})
export class AdjuntoComponent implements OnInit {

  activos: Adjunto[] = [];
  inactivos: Adjunto[] = [];
  eliminados: Adjunto[] = [];

  contIdsNuevos = -1;

  loaders = {
    image: false,
    form: false,
    edit: false
  };
  page = 1;
  pageSize = 18;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType: APP_CONTS.FILES.IMAGE_FORMAT
  });

  constructor(
    private dragulaService: DragulaService,
    private toasts: ToastsManager,
    private adjuntoService: AdjuntoService,
    private imageResizeService: ImageResizeService,
    private modalService: NgbModal,
  ) {
    dragulaService.setOptions('bag-adjunto', {
    });

    dragulaService.dropModel.subscribe((value) => {
      this.onDropModel(value.slice(1));
    });
    dragulaService.removeModel.subscribe((value) => {
      this.onRemoveModel(value.slice(1));
    });
  }

  private onDropModel(args) {
    let [el, target, source] = args;
    // do something else
  }

  private onRemoveModel(args) {
    let [el, source] = args;
    // do something else
  }

  ngOnInit() {
    this.adjuntoService.all()
      .subscribe((resp) => {
        _.each(resp.data, (adjunto: IAdjunto) => {
          if (adjunto.activo === 'ACTIVO') {
            this.activos.push(new Adjunto(adjunto));
          } else {
            this.inactivos.push(new Adjunto(adjunto));
          }
        });
      });
  }

  crearNuevo() {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {
        this.loaders.image = true;
        const newAdjunto = new Adjunto({
          id: this.contIdsNuevos,
          activo: 'INACTIVO',
          esNuevo: true,
          imagen: '',
          nuevaImagen: file,
          tipo: 'ADJUNTO_COTIZACION',
          modificado: false,
        });

        let name = file.name.replace(/\_/g, ' ');
        name = name.replace(/-/g, ' ');
        name = name.substring(0, name.lastIndexOf('.'));

        this.imageResizeService.resize([file], 1024, 768)
          .subscribe((result) => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              newAdjunto.imagen = e.target.result;
            };
            reader.readAsDataURL(result);

            this.loaders.image = false;
            const viewModal = this.modalService.open(EditAdjuntoComponent, { size: 'lg', windowClass: 'modal-admin' });
            viewModal.componentInstance.newAdjunto = newAdjunto;
            this.loaders.edit = true;

            viewModal.result
              .then((createAdjunto: Adjunto) => {
                this.loaders.edit = false;
                this.contIdsNuevos--;
                createAdjunto.esNuevo = true;

                if (createAdjunto.activo === 'ACTIVO') {
                  this.activos.push(createAdjunto);
                } else {
                  this.inactivos.push(createAdjunto);
                }
              }, (reason) => {
                this.loaders.edit = false;
              });

          });
      }
    } else {
      console.log('Archivo no valido');
    }
  }

  guardarCambios() {
    this.loaders.form = true;
    const obsEliminar = [];
    const obsCrear = [];
    const obsModificar = [];

    let errorEliminar = [];
    let errorCrear = [];
    let errorModificar = [];

    const nuevosFinal = _.union(_.filter(this.activos, { 'esNuevo': true }), _.filter(this.inactivos, { 'esNuevo': true }));

    const modActivos = _.filter(this.activos, (o: Adjunto) => {
      if (!o.esNuevo && o.modificado) {
        return o;
      }
    });
    const modInactivos = _.filter(this.inactivos, (o: Adjunto) => {
      if (!o.esNuevo && o.modificado) {
        return o;
      }
    });

    const modificadosFinal = _.union(modActivos, modInactivos);

    /**
     * 1. Elimino.
     */

    _.each(this.eliminados, (adjunto) => {
      obsEliminar.push(this.adjuntoService.eliminar(adjunto.id));
    });

    /**
     * 2. Creo.
     */
    _.each(nuevosFinal, (adjunto: Adjunto) => {
      obsCrear.push(this.adjuntoService.crear(adjunto.getFormData()));
    });

    /**
     * 3. Modifico
     */
    _.each(modificadosFinal, (adjunto: Adjunto) => {
      obsModificar.push(this.adjuntoService.edit(adjunto.id, adjunto.getFormData()));
    });

    forkJoin(obsEliminar)
      .pipe(
        finalize(() => {
          forkJoin(obsCrear)
            .pipe(
              finalize(() => {
                forkJoin(obsModificar)
                  .pipe(
                    finalize(() => {
                      if (errorEliminar.length === 0 && errorCrear.length === 0 && errorModificar.length === 0) {
                        this.toasts.success('Cambios guardados');

                        this.activos = [];
                        this.inactivos = [];
                        this.adjuntoService.all()
                          .subscribe((resp) => {
                            _.each(resp.data, (adjunto: IAdjunto) => {
                              if (adjunto.activo === 'ACTIVO') {
                                this.activos.push(new Adjunto(adjunto));
                              } else {
                                this.inactivos.push(new Adjunto(adjunto));
                              }
                            });
                          });


                      } else {
                        let mensaje = '<ul>';

                        if (errorEliminar.length > 0) {
                          mensaje = mensaje + '<li>Han ocurrido problemas al eliminar los Adjuntos</li>';
                          console.error(errorEliminar);
                        }
                        if (errorCrear.length > 0) {
                          mensaje = mensaje + '<li>Han ocurrido problemas al crear los nuevos Adjuntos</li>';
                          console.error(errorCrear);
                        }
                        if (errorModificar.length > 0) {
                          mensaje = mensaje + '<li>Han ocurrido problemas al modificar Adjuntos</li>';
                          console.error(errorModificar);
                        }
                        mensaje = mensaje + '</ul>';

                        if (errorEliminar.length === 0 || errorCrear.length === 0 || errorModificar.length === 0) {
                          mensaje = mensaje + '<p>Las demás acciones se han realizado con éxito</p>';
                        }
                        this.toasts.warning(mensaje, 'Ups...', { enableHTML: true });
                      }

                      this.loaders.form = false;
                    }))
                  .subscribe((resp) => {
                  }, (errors) => {
                    errorModificar = errors;
                  });
              }))
            .subscribe((resp) => {
            }, (errors) => {
              errorCrear = errors;
            });
        }))
      .subscribe((resp) => {
      }, (errors) => {
        errorEliminar = errors;
      });
  }

  editar(adjunto: Adjunto, publicado: boolean) {
    const clon: Adjunto = _.clone(adjunto);
    const viewModal = this.modalService.open(EditAdjuntoComponent, { size: 'lg', windowClass: 'modal-admin' });
    viewModal.componentInstance.adjunto = clon;

    this.loaders.edit = true;

    viewModal.result
      .then((newAdjunto: Adjunto) => {
        this.loaders.edit = false;
        newAdjunto.modificado = true;
        if (publicado) {
          const index = _.findIndex(this.activos, { 'id': newAdjunto.id });

          if (newAdjunto.activo === 'ACTIVO') {
            this.activos[index] = newAdjunto;
          } else {
            _.remove(this.activos, { 'id': newAdjunto.id });
            this.inactivos.push(newAdjunto);
          }
        } else {
          const index = _.findIndex(this.inactivos, { 'id': newAdjunto.id });

          if (newAdjunto.activo === 'ACTIVO') {
            _.remove(this.inactivos, { 'id': newAdjunto.id });
            this.activos.push(newAdjunto);
          } else {
            this.inactivos[index] = newAdjunto;
          }
        }
      }, (reason) => {
        this.loaders.edit = false;
      });
  }

  eliminar(adjunto: Adjunto) {
    if (adjunto.activo === 'ACTIVO') {
      _.remove(this.activos, { 'id': adjunto.id });
    } else {
      _.remove(this.inactivos, { 'id': adjunto.id });
    }

    this.eliminados.push(adjunto);
  }


}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/adjunto/adjunto.component.ts